<div class="offcanvas-header border-bottom">
  <h5 id="offcanvasLabel" class="fw-semibold mb-0">
    Service Usage
  </h5>
  <button type="button" class="btn-close no-drag" (click)="closeOffcanvas()"></button>
</div>

<div class="offcanvas-body">
  <div class="balance" [ngClass]="getAmountClass()">
    <p class="fw-normal">Unpaid balance</p>
    <p class="amount">{{AmountUtils.formatAmount(wallet?.unpaidTotal, 'EUR')}}</p>
  </div>

  <div class="alert alert-danger d-flex gap-2 align-items-start" *ngIf="wallet?.blocked">
    <i class="ti ti-alert-triangle"></i>
    <span>Services blocked: your unpaid balance has reached {{AmountUtils.formatAmount(wallet?.threshold, 'EUR')}}. Pay your open invoices to restore them.</span>
  </div>

  <div class="alert alert-info d-flex gap-2 align-items-start" *ngIf="!paymentsEnabled">
    <i class="ti ti-info-circle"></i>
    <span>Online payments are temporarily unavailable. Please contact support to settle your invoices.</span>
  </div>

  <div class="invoices" *ngIf="unpaidInvoices.length > 0">
    <p class="section-title">Invoices to pay</p>
    <div class="invoice-row" *ngFor="let invoice of unpaidInvoices">
      <div class="details-row-text">
        <span class="details-row-title">{{invoice.number}}</span>
        <span class="details-row-date">{{invoice.issuedAt | date:'dd/MM/yyyy':'':'en-US'}}</span>
      </div>
      <span class="details-row-amount">{{AmountUtils.formatAmount(invoice.totalAmount, 'EUR')}}</span>
      <app-button *ngIf="profileService.isOwner && paymentsEnabled" (onClick)="payInvoice(invoice)" [isDisabled]="isLoading" [isLoading]="isLoading" label="Pay"></app-button>
    </div>
  </div>

  <div class="uninvoiced" *ngIf="(wallet?.uninvoicedTotal ?? 0) > 0">
    <p class="section-title">Charges not yet invoiced</p>
    <div class="invoice-row">
      <span class="details-row-title">{{pendingEntries.length}} {{pendingEntries.length === 1 ? 'item' : 'items'}}</span>
      <span class="details-row-amount">{{AmountUtils.formatAmount(wallet?.uninvoicedTotal, 'EUR')}}</span>
      <app-button *ngIf="profileService.isOwner && paymentsEnabled" (onClick)="payPending()" [isDisabled]="isLoading" [isLoading]="isLoading" label="Pay now"></app-button>
    </div>

    <div class="details" *ngIf="pendingEntries.length > 0">
      <button type="button" class="details-toggle" (click)="toggleDetails()" [attr.aria-expanded]="detailsOpen">
        <span class="details-title">
          Details <span class="details-count">({{pendingEntries.length}} {{pendingEntries.length === 1 ? 'item' :
            'items'}})</span>
        </span>
        <i class="ti" [ngClass]="detailsOpen ? 'ti-chevron-up' : 'ti-chevron-down'"></i>
      </button>

      <div class="details-panel" *ngIf="detailsOpen">
        <div class="details-row" *ngFor="let entry of pendingEntries">
          <div class="details-row-text">
            <span class="details-row-title">{{entryLabel(entry)}}</span>
            <span class="details-row-date">{{entry.createdAt | date:'dd/MM/yyyy HH:mm':'':'en-US'}}</span>
          </div>
          <span class="details-row-amount">{{AmountUtils.formatAmount(entry.amount, 'EUR')}}</span>
        </div>

        <div class="details-total">
          <span>Total</span>
          <span>{{AmountUtils.formatAmount(wallet?.uninvoicedTotal, 'EUR')}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="empty-state text-center py-5" *ngIf="unpaidInvoices.length === 0 && (wallet?.uninvoicedTotal ?? 0) <= 0">
    <i class="ti ti-receipt-off fs-1 text-muted mb-3"></i>
    <p class="text-muted">Nothing to pay</p>
  </div>

  <p class="text-muted small mt-3" *ngIf="!profileService.isOwner && (unpaidInvoices.length > 0 || (wallet?.uninvoicedTotal ?? 0) > 0)">
    Contact the clinic owner to pay
  </p>

  <p class="funds text-muted">Charges are invoiced on the 1st of each month, or immediately when the limit is reached.</p>
</div>

<!-- ===== PAYMENT MODAL OVERLAY ===== -->
<div class="payment-modal-backdrop" *ngIf="paymentReady || paymentSuccess" (click)="onBackdropClick($event)">
  <div class="payment-modal" role="dialog" aria-modal="true">

    <!-- Header modale -->
    <div class="payment-modal-header">
      <div class="d-flex align-items-center gap-2">
        <i class="ti ti-lock fs-5 text-muted"></i>
        <span class="fw-semibold">Secure Payment</span>
      </div>
      <button type="button" class="btn-close" (click)="cancelPayment()" [disabled]="isLoading"></button>
    </div>

    <!-- Body modale -->
    <div class="payment-modal-body">

      <!-- Stripe Payment Element -->
      <div *ngIf="!paymentSuccess">
        <div class="amount-summary mb-3">
          <div class="amount-summary-row">
            <span class="amount-label">
              <i class="ti ti-receipt me-1"></i>{{ payingLabel }}
            </span>
            <span class="amount-value">{{ AmountUtils.formatAmount(payingAmount, 'EUR') }}</span>
          </div>
        </div>

        <div #stripePaymentElement id="stripe-payment-element"></div>

        <div *ngIf="paymentError" class="alert alert-danger py-2 small mt-3">
          <i class="ti ti-alert-circle me-1"></i>{{ paymentError }}
        </div>
      </div>

      <!-- Successo -->
      <div *ngIf="paymentSuccess" class="text-center py-4">
        <div class="success-icon mb-3">
          <i class="ti ti-circle-check"></i>
        </div>
        <p class="fw-semibold fs-5 mb-1">Payment Successful!</p>
        <p class="text-muted small">Your service usage has been updated.</p>
      </div>

    </div>

    <!-- Footer modale -->
    <div class="payment-modal-footer" *ngIf="!paymentSuccess">
      <app-button (onClick)="confirmPayment()"
        [isDisabled]="isLoading"
        [isLoading]="isLoading"
        label="Pay {{ AmountUtils.formatAmount(payingAmount, 'EUR') }}">
      </app-button>
    </div>

    <!-- Stripe badge -->
    <div class="stripe-badge">
      <span class="text-muted" style="font-size:10px">Powered by</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="16" viewBox="0 0 60 25" fill="#635bff">
        <path d="M59.6 14.3c0-4.8-2.3-8.6-6.8-8.6-4.5 0-7.2 3.8-7.2 8.5 0 5.6 3.2 8.5 7.8 8.5 2.2 0 3.9-.5 5.2-1.3v-3.7c-1.3.7-2.8 1.1-4.6 1.1-1.8 0-3.4-.6-3.6-2.8h9.1c0-.2.1-.9.1-1.7zm-9.2-1.8c0-2.1 1.3-2.9 2.4-2.9 1.1 0 2.3.8 2.3 2.9h-4.7zM41.4 5.7c-1.8 0-3 .8-3.7 1.4l-.2-1.2h-4.1v21.9l4.7-1 .1-5.3c.7.5 1.7.8 3 .8 3 0 5.8-2.4 5.8-7.8 0-4.9-2.8-8.8-5.6-8.8zm-1 13.5c-1 0-1.6-.4-2-.8l-.1-6.4c.4-.5 1.1-.8 2.1-.8 1.6 0 2.7 1.8 2.7 4 0 2.3-1 4-2.7 4zM32.6 4.5l-4.7 1v3.7l4.7-1V4.5zm-4.7 1.5h4.7V22h-4.7V6zM23 7.1l-.3-1.3h-4v16.1h4.7v-10.9c1.1-1.4 2.9-1.2 3.5-1v-4.3C26.2 5.5 24.1 5.2 23 7.1zM13.8 2.4L9.2 3.4l-.1 14.6c0 2.7 2 4.7 4.8 4.7 1.5 0 2.6-.3 3.2-.6v-3.8c-.6.2-3.5 1.1-3.5-1.7V9.8h3.5V5.9h-3.5l.2-3.5zM3.8 9.3C2.8 9.3 2.3 9 2.3 8.3c0-.8.8-1.2 2.1-1.2 1.9 0 3.9.6 5.8 1.6V4.2C8.4 3.4 6.5 3 4.5 3 1.8 3 0 4.4 0 7c0 4 5.5 3.4 5.5 5.1 0 .9-.8 1.2-2.1 1.2-1.8 0-4.1-.7-5.9-1.8v4.6C-.7 17 1.6 17.5 3.4 17.5c2.8 0 4.7-1.4 4.7-4-0.1-4.3-5.3-3.5-4.3-4.2z"/>
      </svg>
    </div>

  </div>
</div>
